import React, { forwardRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { t } from 'i18next';
import siteSetup from 'src/js/modules/site-setup';
import utils from '../../utils';
import BlankTemplateActionButton from './blank-template-action-button';
import { PREVIEW_COLUMNS_COUNT, DESKTOP_VIEW_BREAKPOINT } from '../../constants/common';
import BusinessCategoryFieldContainer from '../../containers/business-category-field-container';

const { Container, ActionButton, IconButtonGroup } = designSystem;
const { useMatchBreakpoint } = utils.hooks;

const { constants } = siteSetup;
const { siteSetupNames } = constants;

const ACTION_BUTTONS_VISIBILITY_BREAKPOINT = '1200px';

const CategoriesBar = forwardRef(
  (
    {
      control,
      onCategorySelect = Function.prototype,
      onBlankTemplateClick = Function.prototype,
      onFilterTemplateClick = Function.prototype,
      gridColumns = PREVIEW_COLUMNS_COUNT.twoColumns,
      handleColumnsToggle,
    },
    ref
  ) => {
    const isDesktopView = useMatchBreakpoint(DESKTOP_VIEW_BREAKPOINT);
    const areActionButtonsVisible = useMatchBreakpoint(ACTION_BUTTONS_VISIBILITY_BREAKPOINT);

    return (
      <Fragment>
        <div className="categories-bar" ref={ref}>
          <div className="categories-bar__wrapper">
            <Container>
              <div className="categories-bar__content">
                {isDesktopView && (
                  <Fragment>
                    <div className="categories-bar__select">
                      <BusinessCategoryFieldContainer
                        control={control}
                        stepId={siteSetupNames.GALLERY}
                        size="medium"
                        onChange={onCategorySelect}
                      />
                    </div>
                    <div className="categories-bar__action-btns">
                      {areActionButtonsVisible && (
                        <IconButtonGroup
                          gap="spacing-4-xs"
                          actions={[
                            {
                              glyph: 'grid',
                              size: 'large',
                              onClick: () => handleColumnsToggle(PREVIEW_COLUMNS_COUNT.twoColumns),
                              selected: gridColumns === PREVIEW_COLUMNS_COUNT.twoColumns,
                            },
                            {
                              glyph: 'grid-2',
                              size: 'large',
                              onClick: () =>
                                handleColumnsToggle(PREVIEW_COLUMNS_COUNT.threeColumns),
                              selected: gridColumns === PREVIEW_COLUMNS_COUNT.threeColumns,
                            },
                          ]}
                        />
                      )}
                      <div className="categories-bar__action-btn">
                        <BlankTemplateActionButton onClick={onBlankTemplateClick} />
                      </div>
                    </div>
                  </Fragment>
                )}
                {!isDesktopView && (
                  <Fragment>
                    <ActionButton
                      fullWidth
                      format="text"
                      iconGlyph="filter"
                      label={t('Filter templates')}
                      onClick={onFilterTemplateClick}
                    />
                    <span className="categories-bar__vertical-divider" />
                    <BlankTemplateActionButton fullWidth onClick={onBlankTemplateClick} />
                  </Fragment>
                )}
              </div>
            </Container>
          </div>
        </div>
      </Fragment>
    );
  }
);

CategoriesBar.displayName = 'CategoriesBar';

CategoriesBar.propTypes = {
  control: PropTypes.shape({}).isRequired,
  onCategorySelect: PropTypes.func,
  gridColumns: PropTypes.oneOf(Object.values(PREVIEW_COLUMNS_COUNT)),
  onBlankTemplateClick: PropTypes.func,
  onFilterTemplateClick: PropTypes.func,
  handleColumnsToggle: PropTypes.func.isRequired,
};

export default CategoriesBar;
